import { CategoryModel, updateCategoryModel } from "./CategoryModel";
import { TypeModel, updateTypeModel } from "./TypeModel";

export function Catalog() {
    const list = [];

    const update = (data) => {
        list.length = 0;

        data.forEach((category) => {
            const model = CategoryModel(category);
            list.push(model);
        });

        console.log(list);
    };

    const getCategory = (categoryId) => {
        const id = categoryId.toString();
        return list.find((c) => c.id === id);
    };

    const getSubCategory = (subCategoryId) => {
        let result = null;
        const id = subCategoryId.toString();

        for (let i = 0, count = list.length; i < count; i++) {
            const category = list[i];
            const { subCategories } = category;

            const subCategory = subCategories.find((item) => item.id === id);
            if (subCategory) {
                result = subCategory;
                break;
            }
        }

        return result;
    };

    const getCategoryOrSubCategory = (categoryId) => {
        const category = getCategory(categoryId);
        if (category) return category;
        return getSubCategory(categoryId);
    };

    const openCategory = (categoryId) => {
        const category = getCategoryOrSubCategory(categoryId);

        if (!category) return;

        const { parentId } = category;

        if (parentId) {
            const parent = getCategory(parentId);
            parent.isVisible = true;
        }

        category.isVisible = true;
    };

    const closeCategory = (categoryId) => {
        const category = getCategoryOrSubCategory(categoryId);

        if (!category) return;

        category.isVisible = false;

        if (category.subCategories) {
            category.subCategories.forEach((subCategory) => {
                subCategory.isVisible = false;
            });
        }
    };

    const addSubCategoryToCategory = (categoryId, subCategory) => {
        if (!categoryId) return;
        if (!subCategory) return;
        const category = getCategory(categoryId);
        if (!categoryId) return;
        category.subCategories.unshift(subCategory);
    };

    const removeSubCategoryFromCategory = (categoryId, subCategoryId) => {
        if (!categoryId) return;
        const category = getCategory(categoryId);
        if (!categoryId) return;
        const id = subCategoryId.toString();
        category.subCategories = category.subCategories && category.subCategories.filter((item) => item.id.toString() !== id);
    };

    const addCategory = (categoryData) => {
        const model = CategoryModel(categoryData);
        const { parentId } = model;

        if (!parentId) {
            list.unshift(model);
        } else {
            const parentCategory = getCategory(parentId);
            if (parentCategory) {
                parentCategory.subCategories.unshift(model);
            }
        }

        return model;
    };

    const removeCategory = (categoryId, onlyCategories) => {
        const category = getCategoryOrSubCategory(categoryId);
        if (!onlyCategories && category.parentId) {
            removeSubCategoryFromCategory(category.parentId, categoryId);
        } else {
            const id = categoryId.toString();
            const index = list.findIndex((category) => category.id.toString() === id.toString());
            list.splice(index, 1);
        }
    };

    const updateCategory = (categoryData) => {
        const model = CategoryModel(categoryData);
        const { parentId, id } = model;

        const original = getCategoryOrSubCategory(id);
        const { parentId: originalParentId } = original;

        // родитель не изменился
        if (parentId === originalParentId) return  updateCategoryModel(original, model);

        if (originalParentId) {
            // удалить у предыдущего родителя
            removeSubCategoryFromCategory(originalParentId, id);
        } else {
            removeCategory(id, true);
        }
        const updatedCategory = updateCategoryModel(original, model);

        // добавить новому родителю
        if (parentId) {
            //console.log(updatedCategory);

            addSubCategoryToCategory(parentId, updatedCategory);
        } else {
            addCategory(updatedCategory);
        }

        return updatedCategory;
    };

    const getType = (typeId) => {
        let result = null;
        const id = typeId.toString();

        for (let i = 0, iCount = list.length; i < iCount; i++) {
            const category = list[i];
            const { types, subCategories } = category;
            const type = types.find((t) => t.id === id);
            if (type) {
                result = type;
                break;
            }

            for (let j = 0, jCount = subCategories.length; j < jCount; j++) {
                const subCategory = subCategories[j];
                const type = subCategory.types.find((child) => child.id === id);
                if (type) {
                    result = type;
                    break;
                }
            }
            if (result) break;
        }

        return result;
    };

    const addTypeToCategory = (categoryId, type) => {
        const parentCategory = getCategoryOrSubCategory(categoryId);
        if (!parentCategory) return;

        parentCategory.types.push(type);
    };

    const addType = (data) => {
        const model = TypeModel(data);
        const { parentId } = model;
        addTypeToCategory(parentId, model);
        return model;
    };

    const removeTypeFromCategory = (categoryId, typeId) => {
        if (!categoryId) return;
        const category = getCategoryOrSubCategory(categoryId);

        if (!category) return;

        const id = typeId.toString();
        const index = category.types.findIndex((child) => child.isType && child.id === id);
        category.types.splice(index, 1);
    };

    const removeType = (typeId) => {
        const type = getType(typeId);
        if (!type) return;

        removeTypeFromCategory(type.parentId, typeId);
    };

    const updateType = (data) => {
        const model = TypeModel(data);
        const { id, parentId } = model;

        const original = getType(id);
        const { parentId: originalParentId } = original;

        const updatedType = updateTypeModel(original, model);

        // родитель не изменился
        if (parentId === originalParentId) return updatedType;

        // удалить у предыдущего родителя
        removeTypeFromCategory(originalParentId, id);

        // добавить новому родителю
        addTypeToCategory(parentId, updatedType);

        return updatedType;
    };

    const moveTypeToArchive = (typeId) => {
        const type = getType(typeId);
        if (!type) return;

        type.isArchive = true;
    };

    const moveTypeFromArchive = (typeId) => {
        const type = getType(typeId);
        if (!type) return;

        type.isArchive = false;
    };

    return {
        list,

        update,

        getCategory,
        getSubCategory,
        getCategoryOrSubCategory,
        getType,

        openCategory,
        closeCategory,

        addType,
        updateType,
        removeType,

        moveTypeToArchive,
        moveTypeFromArchive,

        addCategory,
        updateCategory,
        removeCategory,
    };
}
